//@ts-ignore
window.SkipToConfig = {
    settings: {
        skipTo: {
            displayOption: "popup",
        },
    },
};
